/** Created by azhou on 2019/3/12.*/
<template>
  <div>
    <div class="load-area">
      <gcon-search @getSearchCon="getSearchCon" />
      <p v-if="StoreLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head">
          <li :class="item=='负责人数'||item=='操作'||item=='认证状态'||item=='活跃值'?'w-20':'w-50'" v-for="item in titleArr" :key="item">{{item}}</li>
        </ul>
        <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col list-item-title">
            <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
          </li>
          <!-- <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
            {{Itemize.verify | formatVar('verifyType')}}<span class="text-link" v-show="Itemize.verify === 0" @click="goVerify(Itemize)">（去认证）</span>
          </li> -->
          <li class="w-20 list-item-col">
            <el-popover v-if="Itemize.store_user_arr" placement="right" trigger="hover">
              <div v-for="(v,ind) in Itemize.store_user_arr" :key="ind">
                <i class="iconfont icon-weixin1 mr-1" :class="[v.wechat_openid ? 'text-success' : 'text-muted']"></i>
                <span class="mr-2">{{v.truename}}</span><span class="mr-2">{{v.name}}</span>
                <span class="mr-2">{{v.mobile}}</span>
              </div>
              <span slot="reference" class="text-link">{{Itemize.store_user_arr.length}}</span>
            </el-popover>
          </li>
          <li class="w-20 list-item-col">
              <span :class="[Itemize.verify==1 ?'text-success':'text-danger']">{{Itemize.verify==1?'已认证':'未认证'}} </span>
          </li>
          <li class="w-20 list-item-col">{{Itemize.exp}}</li>
          <li class="w-50 list-item-col">
            {{Itemize.province_name}}-{{Itemize.city_name}}
          </li>
          <li class="w-50 list-item-col" v-if="storeInfo.type == 3 || storeInfo.type == 6">
            <span v-if="storeInfo.type == 3">{{Itemize.star | formatVar('HotelStar')}}</span>
            <span class="text-info" v-else>{{Itemize.star | formatVar('scenicStarArr')}}</span>
          </li>
          <li class="w-20 list-item-col-end">
            <span class="text-link" @click="goForDetail(Itemize)" v-if="Itemize.verify === 1">{{showPost ? '发布订单' : '编辑认证'}}</span>
            <span class="text-danger text-link" @click="goForDetail(Itemize)" v-else>去认证</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="StoreLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState,mapActions } from 'vuex'
  import GconSearch from '../../GconSearch'

  export default {
    name: 'GroupStoreLists',
    components: { GconSearch },
    computed: {
      ...mapState(['StoreLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      travel () { return this.storeInfo.type == 2 },
      showPost () { return this.queryCon.order || Boolean(this.queryCon.hotel) },
      titleArr() {
        switch (this.storeInfo.type) {
          case 3:
            return ['门店名称','负责人数','认证状态','活跃值','门店地址','门店星级','操作']
            break;
          case 2:
          case 5:
            return ['门店名称','门店认证','负责人数','门店地址','操作']
            break;
          case 6:
            return ['景区名称','门店认证','负责人数','景区地址','景区星级','操作']
            break;
        }
      }
    },
    watch:{
      queryCon() { 
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {...this.info} })
        else this.groupGetStoreLists({ page:this.queryCon.page, type:1,...this.info })  
      },
    },
    data() {
      return {
        info: {},
        url: 'pc/Travel/getStoreMaterial'
      }
    },
    created() {
      if (this.queryCon.hasOwnProperty('page')) {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url})
        else this.groupGetStoreLists({ page:this.queryCon.page, type:1 })
      } else {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1} })
        else this.groupGetStoreLists({ page:1, type:1 })
      }
    },
    methods:{
      ...mapActions(['groupGetStoreLists','TraGroupGetStoreLists']),
      //门店去认证
      goVerify(item) {
        this.$router.push({name:'GroupAddStore',query:{step:1,store:item.store_id}})
      },
      goForDetail(Itemize) {
        this.$router.push({name:this.$route.name,query:{store:Itemize.store_id,GST:Itemize.title,type:this.queryCon.type,...this.queryCon}})
      },
      editStore(Itemize) {
        this.$router.push({name:'GroupAddStore',query:{store:Itemize.store_id,GST:Itemize.title}})
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id,none:1}});
        window.open(routeUrl.href, '_blank');
      },
      getSearchCon (info) {
        this.info=info;
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1, ...info} })
        else this.groupGetStoreLists({ page:1, type:1, ...info })
      },
      addStore () {
        if (!this.$GFUN.powerIsInArray([542,543,544,545])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'GroupAddStore',query:{step:1,add:'new'}})
      }
    }
  }
</script>
